export default {
  en: {
    unmute: 'Turn on notifications',
    mute: 'Turn off notifications',
    mark_all_as_read: 'Mark all as read',
    errors: {
      not_delivered: 'Not delivered',
    },
  },
};
